$('.js-vouchers-form').on('submit', e => e.preventDefault()).validate({
    submitHandler: function (form) {
        var $form = $(form);

        $form.find('input[name="voucher"]').blur();
        $form.find('button[type="submit"]').addClass('is-loading');

        window.assignRecaptchaResponseToForm(form).then(() => {
            Form.ajaxPost(form, function (data) {
                Eshop.alert(data.message, { type: data.status ? 'success' : 'error' });

                if (data.status) {
                    location.reload();
                } else {
                    $form.find('button[type="submit"]').removeClass('is-loading');
                }
            }, "json");
        });
    }
});

$(function () {
    $('.js-import-form-input').on('change', function () {
        $('.js-import-form').submit();

        $(this).prop('disabled', true);
        $(this).siblings('.c-btn').addClass('is-loading');
    });

    $('.js-cart-clear').on('click', function (e) {
        e.preventDefault();

        const msg = $(this).data('msg');
        const href = $(this).attr('href');

        Eshop.confirm(msg, {
            confirmButtonText: $(this).data('confirm-text')
        }, () => {
            window.location.href = href;
        });
    });
});